<footer
    #user="user"
    class="footer"
    lsUser
>
    <div
        *lsUiNgLet="user.userInfo$ | async as userInfo"
        class="footer__content container"
    >
        <ul class="footer__categories">
            <ng-template
                #navTemplate
                let-desktop="desktop"
                let-nav="nav"
            >
                <nav
                    class="footer__nav"
                    [class._desktop]="desktop"
                >
                    @for (link of nav; track $index) {
                        @if (link.alias !== "lucky-wheel" && !link.external) {
                            <a
                                class="footer__nav-link link _subtle-dark _system-p-sm _500"
                                routerLinkActive="_active"
                                [routerLink]="link.url ? [link.url | localize] : null"
                            >
                                {{ link.name | translate }}
                            </a>
                        } @else if (link.external) {
                            <a
                                class="footer__nav-link link _subtle-dark _system-p-sm _500"
                                target="_blank"
                                [href]="link.url"
                            >
                                {{ link.name | translate }}
                            </a>
                        } @else if (hasLuckyWin) {
                            <button
                                class="footer__nav-link link _subtle-dark _system-p-sm _500"
                                type="button"
                                (click)="userInfo ? openWheel() : openWheelRegistration()"
                            >
                                {{ link.name | translate }}
                            </button>
                        }
                    }
                </nav>
            </ng-template>

            @for (item of navigationsList; track $index) {
                <li class="footer__category-item">
                    <button
                        class="footer__category-title _graphic-sub-xs _500"
                        type="button"
                        [class._active]="accordionState[$index]"
                        (click)="toggleAccordion($index)"
                    >
                        {{ item.title | translate }}
                        <ls-ui-icon
                            class="footer__category-icon"
                            height="24"
                            src="chevron"
                            width="24"
                            [class._active]="accordionState[$index]"
                        />
                    </button>

                    @if (accordionState[$index]) {
                        <ng-container
                            *ngTemplateOutlet="navTemplate; context: {
                                    nav: item.nav,
                                    desktop: false,
                                }"
                        />
                    }
                    <h3 class="footer__category-title _graphic-sub-xs _500 _desktop">{{ item.title | translate }}</h3>
                    <ng-container
                        *ngTemplateOutlet="navTemplate; context: {
                                nav: item.nav,
                                desktop: true,
                            }"
                    />
                </li>
            }

            <li class="footer__lang-support">
                <button
                    class="footer__lang-support-btn"
                    lsChooseLangs
                    lsUiButtonKind="basic"
                    lsUiButtonPalette="neutral-1"
                    lsUiButtonSize="small"
                    type="button"
                    (currentLanguageChange)="onLanguageChange($event)"
                >
                    <svg
                        height="24"
                        width="24"
                        [title]="currentLanguage?.value"
                    >
                        <use [attr.xlink:href]="`assets/langs/output/sprite.svg#${currentLanguage?.id | lowercase}`"/>
                    </svg>
                    <span class="_graphic-sub-xs _500">{{ (`popup.choose-langs-country-${currentLanguage?.id}`) | translate }}</span>
                </button>

                <button
                    class="footer__lang-support-btn"
                    lsLivechatButton
                    lsUiButtonKind="basic"
                    lsUiButtonPalette="neutral-1"
                    lsUiButtonSize="small"
                    type="button"
                    [title]="'common.jivo' | translate"
                >
                    <ls-ui-icon
                        height="24"
                        src="support"
                        width="24"
                    />
                    <span class="_graphic-sub-xs _500">{{ "common.button-live-chat" | translate }}</span>
                </button>
            </li>
        </ul>

        <hr class="footer__hr">

        @if (!isMirror && isBrowser) {
            <div class="footer__logos-info">
                <div class="footer__logos">
                    @if (validationUrl) {
                        <div
                            id="anj-a6e05798-c03f-4d36-8af8-5c70f55822ce"
                            data-anj-seal-id="a6e05798-c03f-4d36-8af8-5c70f55822ce"
                            data-anj-image-size="57"
                            data-anj-image-type="basic-small"
                        ></div>
                    }
                    <ls-picture
                        src="footer/logos/age"
                        [autoSize]="false"
                        [height]="40"
                        [lazy]="true"
                        [width]="40"
                    />
                </div>
                <div class="footer__text _system-p-xs">
                    @if (!isMirror && isBrowser) {
                        <p>
                            {{ "common.footer-info1" | translate : { value: uniqueProjectTranslation.projectName } }}
                            {{ "common.footer-info2" | translate }}
                            {{ "common.footer-info3" | translate }}
                        </p>
                    }

                    <!-- TODO hide for now -->
                    <!-- <p>{{"common.footer-info" | translate : { value: uniqueProjectTranslation.projectName } }}</p> -->
                </div>
            </div>
            @if (hasCaptcha) {
                <div>
                    <p class="footer__captcha">
                        This site is protected by reCAPTCHA and the Google
                        <a
                            href="https://policies.google.com/privacy"
                            class="footer__nav-link link"
                            target="_blank"
                        >Privacy Policy</a> and
                        <a
                            href="https://policies.google.com/terms"
                            class="footer__nav-link link"
                            target="_blank"
                        >Terms of Service</a> apply.
                    </p>
                </div>
            }

            <hr class="footer__hr">
        }

        <ng-container
            #paymentSystemsIcons="icons"
            category="payment_systems"
            lsIcons
        >
            @let paymentSystemsIconsVar = paymentSystemsIcons.items$();

            <ls-footer-slider [list]="paymentSystemsIconsVar"/>
        </ng-container>

        <hr class="footer__hr">

        <ng-container
            #partnersIcons="icons"
            category="partners"
            lsIcons
        >
            @let partnersIconsVar = partnersIcons.items$();

            <ls-footer-slider [list]="partnersIconsVar"/>
        </ng-container>

        <hr class="footer__hr">

        <div class="footer__bottom">
            @if (socials.length) {
                <div class="footer__socials">
                    @for (link of socials; track $index) {
                        <a
                            target="_blank"
                            [class]="`footer__socials-item _${link.icon}`"
                            [href]="link.url"
                            [title]="link.name"
                        >
                            <ls-ui-icon
                                height="24"
                                width="24"
                                [src]="link.icon"
                            />
                        </a>
                    }
                </div>
            }

            <!-- TODO hide for now -->
            <!-- <p>{{"common.footer-copyright" | translate : { value: uniqueProjectTranslation.projectName } }}</p> -->

            <div class="footer__rights">
                @if (isMirror) {
                    <ls-picture
                        src="footer/logos/age"
                        [autoSize]="false"
                        [height]="32"
                        [lazy]="true"
                        [width]="32"
                    />
                }
                @if (isBrowser) {
                    <p class="footer__text _system-p-xs">{{ "common.footer-copyright" | translate : { value: uniqueProjectTranslation.projectName } }}</p>
                }
            </div>
        </div>
    </div>
</footer>

